import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {Router} from "@angular/router";
import {ScreenSizeService} from "../../services/screen-size-service/screen-size.service";
import {NavComponent} from "./ui/nav/nav.component";
import {UserService} from "../../auth/user-service/user.service";
import {HealthPillarComponent} from "./ui/health-pillar/health-pillar.component";
import {BannerComponent} from "./ui/banner/banner.component";
import {AppMsalAuthService} from "../../auth/authentication-service/app-msal-auth.service";

/**
 * Header containing responsive nav menu.
 */
@Component({
  selector: 'app-header',
  imports: [
    NavComponent,
    HealthPillarComponent,
    BannerComponent,
  ],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  screenSizeService = inject(ScreenSizeService);
  router = inject(Router);
  userService = inject(UserService);
  protected authService = inject(AppMsalAuthService);
  screenSize = this.screenSizeService.screenSize;
}
